import api from "@/services/api";

export default {
  namespaced: true, // Name of namespace exists here '@/store/namespaces'
  state: {
    spendingCategories: null,
  },
  getters: {
    getSpendingCategories: (state) => {
      return state.spendingCategories;
    },
  },
  mutations: {
    setSpendingCategories: (state, categories) => {
      state.spendingCategories = categories;
    },
  },
  actions: {
    async fetchSpendingCategories({ getters, commit }, params) {
      try {
        // Since categories are not expected to change often, we can check if we already have them in the state before making an API call. This can help reduce unnecessary network requests and improve performance.
        if (getters.getSpendingCategories) {
          return getters.getSpendingCategories;
        }

        const response = await api.get("/spending-categories", { params });

        // Set the data raw, as is, no formatting or mapping, to keep it consistent
        commit("setSpendingCategories", response.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
  },
};
